var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.$_collectors),function(collector){return _c('router-link',{key:collector.Id,staticClass:"block",attrs:{"to":'collector/'+collector.Id.toString()}},[_vm._v(_vm._s(collector.Name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }